import {mapWoodCatalogueRows,sortWoodCatalogue,woodFromRow} from './wood-catalogue.js';

export const WOOD_CATALOGUE_CACHE_ENTITY='wood_catalogue_item';

export const DEFAULT_WOOD_CATALOGUE_ROWS=Object.freeze([
  Object.freeze({key:'alder',species_name:'Alnus glutinosa',display_name_pl:'Olcha',display_name_en:'Alder',catalogue_version:1,sort_order:10,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'beech',species_name:'Fagus sylvatica',display_name_pl:'Buk',display_name_en:'Beech',catalogue_version:1,sort_order:20,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'apple',species_name:'Malus domestica',display_name_pl:'Jabłoń',display_name_en:'Apple',catalogue_version:1,sort_order:30,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'cherry',species_name:'Prunus avium',display_name_pl:'Wiśnia / czereśnia',display_name_en:'Cherry',catalogue_version:1,sort_order:40,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'plum',species_name:'Prunus domestica',display_name_pl:'Śliwa',display_name_en:'Plum',catalogue_version:1,sort_order:50,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'oak',species_name:'Quercus spp.',display_name_pl:'Dąb',display_name_en:'Oak',catalogue_version:1,sort_order:60,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'maple',species_name:'Acer spp.',display_name_pl:'Klon',display_name_en:'Maple',catalogue_version:1,sort_order:70,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'hickory',species_name:'Carya spp.',display_name_pl:'Hikora',display_name_en:'Hickory',catalogue_version:1,sort_order:80,is_active:true,metadata:Object.freeze({})}),
  Object.freeze({key:'mesquite',species_name:'Prosopis spp.',display_name_pl:'Mesquite',display_name_en:'Mesquite',catalogue_version:1,sort_order:90,is_active:true,metadata:Object.freeze({})})
]);

function requireRepository(repository){
  if(!repository?.list||!repository?.put)throw new TypeError('repository with list/put is required');
}

function localeKey(locale){
  return String(locale||'pl').trim().toLowerCase().startsWith('en')?'en':'pl';
}

function normaliseItem(value={}){
  if(value?.displayNames?.pl&&value?.displayNames?.en){
    return woodFromRow({
      key:value.key,
      species_name:value.speciesName,
      display_name_pl:value.displayNames.pl,
      display_name_en:value.displayNames.en,
      catalogue_version:value.catalogueVersion,
      sort_order:value.sortOrder,
      is_active:value.active!==false,
      metadata:value.metadata||{}
    },{locale:'pl'});
  }
  return woodFromRow(value,{locale:'pl'});
}

function mapItems(items,{locale='pl'}={}){
  const lang=localeKey(locale);
  return sortWoodCatalogue((items||[])
    .filter(item=>item?.is_active!==false&&item?.active!==false)
    .map(normaliseItem)
    .map(item=>Object.freeze({...item,displayName:item.displayNames[lang]})));
}

export function createWoodCatalogueService({
  repository,
  remote=null,
  diagnostics=null,
  isOnline=()=>globalThis.navigator?.onLine!==false
}={}){
  requireRepository(repository);
  if(remote!=null&&typeof remote?.list!=='function')throw new TypeError('Wood catalogue remote with list() is required');

  async function cachedItems(){
    const rows=await repository.list(WOOD_CATALOGUE_CACHE_ENTITY);
    return (rows||[])
      .map(item=>item?.catalogueItem??item?.catalogueRow)
      .filter(row=>row&&typeof row==='object');
  }

  async function cache(items){
    for(const input of items||[]){
      const item=normaliseItem(input);
      await repository.put(WOOD_CATALOGUE_CACHE_ENTITY,{id:item.key,catalogueItem:item});
    }
  }

  async function load({locale='pl',refresh=true}={}){
    if(refresh&&remote&&isOnline()){
      try{
        const items=await remote.list();
        if(items?.length){
          await cache(items);
          return Object.freeze({source:'remote',items:mapItems(items,{locale})});
        }
      }catch(error){
        try{diagnostics?.capture?.('smokehouse.wood-catalogue',error);}catch{}
      }
    }

    const cached=await cachedItems();
    if(cached.length)return Object.freeze({source:'cache',items:mapItems(cached,{locale})});
    return Object.freeze({source:'fallback',items:mapWoodCatalogueRows(DEFAULT_WOOD_CATALOGUE_ROWS,{locale})});
  }

  return Object.freeze({load});
}
